import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';

export const Section = styled.section`
  position: relative;

  display: flex;
  flex-direction: column;

  align-items: flex-start;

  background-repeat: no-repeat, no-repeat;
  background-position: center, center;
  background-size: cover;
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-image: url(${({ backgroundImg }) => backgroundImg});
  @media (min-width: 1280px) {
    flex-direction: column;
    text-align: ${({ textHorizAlign }) => textHorizAlign};
    justify-content: ${({ textAlign }) => textAlign};
    height: ${({ height }) => (height ? `${height}vh` : '90vh')};
  }
  @media (min-width: 1920px) and (max-height: 899px) {
    min-height: 855px;
  }
  @media (min-width: 1280px) and (max-height: 699px) {
    min-height: 665px;
  }
`;
export const BackgroundImageOverlay = styled(UI.BackgroundOverlay)``;

export const Video = styled.video`
  width: 100%;
  height: 100%;

  object-fit: cover;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
export const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;

  overflow: hidden;
`;

export const Content = styled(UI.CenterContainer)`
  position: relative;
  z-index: 10;
  @media (min-width: 1280px) {
    margin-left: ${({ textHorizAlign }) =>
    UI.marginAlignMap[textHorizAlign] &&
      UI.marginAlignMap[textHorizAlign].marginLeft};
    margin-right: ${({ textHorizAlign }) =>
    UI.marginAlignMap[textHorizAlign] &&
      UI.marginAlignMap[textHorizAlign].marginRight};
  }

  overflow: visible;
`;



// WEBPACK FOOTER //
// ./src/components/modules/TextSection/styled.js